import { memo } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'baseui/button'
import { ActionsMenuButtonOverrides, ActionsMenuList } from './styled-components'

const buildItems = (row, t, onOpenAbandonModal) => [
  row.hasContract && {
    key: 'signAbandon',
    label: t('contacts.actions.sign_to_abandon'),
    isLoading: row.isSignAbandonLoading,
    disabled: row.signAbandonDisabled,
    onClick: onOpenAbandonModal,
  },
  {
    key: 'reconcileMcpSales',
    label: t('contacts.actions.reconcile_mcp_sales'),
    isLoading: row.isReconcileMcpSalesLoading,
    disabled: row.reconcileMcpSalesDisabled,
    onClick: row.onReconcileMcpSales,
  },
].filter(Boolean)

const ActionsMenuContent = ({ row, t, close, onOpenAbandonModal }) => {
  const items = buildItems(row, t, onOpenAbandonModal)

  return (
    <ActionsMenuList>
      {items.map(item => (
        <Button
          key={item.key}
          size='compact'
          kind='secondary'
          isLoading={item.isLoading}
          disabled={item.disabled}
          title={item.title}
          onClick={() => {
            item.onClick?.()
            close()
          }}
          overrides={ActionsMenuButtonOverrides}
        >
          {item.label}
        </Button>
      ))}
    </ActionsMenuList>
  )
}

ActionsMenuContent.propTypes = {
  row: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  onOpenAbandonModal: PropTypes.func.isRequired,
}

export default memo(ActionsMenuContent)
